module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "bangladesh-landcover-2001-2020--dataset-cover.c192d85d.jpg";